import { css } from 'linaria';

export const root = css`
  display: flex;
  flex-grow: 1;
  padding: var(--space-150);
  background-color: var(--service-light);
  border-radius: var(--rounding-l);
`;

export const wrapper = css`
  width: 100%;
`;

export const top = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
`;

export const left = css`
  display: flex;
  margin-right: var(--space-200);
`;

export const right = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--space-75);
`;

export const centerCol = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--space-50);
`;

export const actions = css`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;

export const imgCol = css`
  margin-right: var(--space-200);
  font-size: 0;
`;

export const imgWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);
`;
